import React from 'react';
import { observer } from 'mobx-react';
import clsx from 'clsx';

import classes from './themeSelector.module.scss';

import RaysSVG from '@/assets/svg/rays.svg';
import { useStorage } from '@/models/Storage';
import { analytics, AnalyticsShow } from '@/utils/analytics';

export const ThemeSelector = observer(() => {
    const { setDarkMode, darkMode } = useStorage();

    return (
        <div className={clsx(classes.themeSelector, darkMode && classes.active)}>
            <button
                className={classes.light}
                onClick={() => {
                    analytics(AnalyticsShow.ThemeLight);
                    setDarkMode(false);
                }}
            >
                День
            </button>

            <div
                className={classes.selector}
                onClick={() => {
                    analytics(darkMode ? AnalyticsShow.ThemeLight : AnalyticsShow.ThemeDark);
                    setDarkMode(!darkMode);
                }}
            >
                <div className={classes.ball}>
                    <RaysSVG />
                </div>
            </div>

            <button
                className={classes.dark}
                onClick={() => {
                    analytics(AnalyticsShow.ThemeDark);
                    setDarkMode(true);
                }}
            >
                Ночь
            </button>
        </div>
    );
});
